if (typeof window._upcartAddonsInit === 'undefined') {
  window._upcartAddonsInit = true;
 
  // ─── NON-PROTECTION ADDON IDs ─────────────────────────────────────────────
  const VAC_ID  = 46861971587241;
  const COLD_ID = 46861971751081;
 
  // ─── TIERED PROTECTION VARIANTS — 19 tiers ───────────────────────────────
  const PROT_TIERS = [
    { id: 46890286874793, minCart: 0,    maxCart: 100,    price: '$2.15',  label: 'Your order is protected for $2.15'  },
    { id: 46912083001513, minCart: 101,  maxCart: 150,    price: '$2.25',  label: 'Your order is protected for $2.25'  },
    { id: 46912083034281, minCart: 151,  maxCart: 200,    price: '$3.00',  label: 'Your order is protected for $3.00'  },
    { id: 46912083067049, minCart: 201,  maxCart: 250,    price: '$3.75',  label: 'Your order is protected for $3.75'  },
    { id: 46912083099817, minCart: 251,  maxCart: 300,    price: '$4.50',  label: 'Your order is protected for $4.50'  },
    { id: 46912083132585, minCart: 301,  maxCart: 350,    price: '$5.25',  label: 'Your order is protected for $5.25'  },
    { id: 46912083165353, minCart: 351,  maxCart: 400,    price: '$6.00',  label: 'Your order is protected for $6.00'  },
    { id: 46912083198121, minCart: 401,  maxCart: 450,    price: '$6.75',  label: 'Your order is protected for $6.75'  },
    { id: 46890286907561, minCart: 451,  maxCart: 500,    price: '$7.50',  label: 'Your order is protected for $7.50'  },
    { id: 46912083230889, minCart: 501,  maxCart: 550,    price: '$8.25',  label: 'Your order is protected for $8.25'  },
    { id: 46912083263657, minCart: 551,  maxCart: 600,    price: '$9.00',  label: 'Your order is protected for $9.00'  },
    { id: 46912083296425, minCart: 601,  maxCart: 650,    price: '$9.75',  label: 'Your order is protected for $9.75'  },
    { id: 46912083329193, minCart: 651,  maxCart: 700,    price: '$10.50', label: 'Your order is protected for $10.50' },
    { id: 46912083361961, minCart: 701,  maxCart: 750,    price: '$11.25', label: 'Your order is protected for $11.25' },
    { id: 46912083394729, minCart: 751,  maxCart: 800,    price: '$12.00', label: 'Your order is protected for $12.00' },
    { id: 46890286940329, minCart: 801,  maxCart: 850,    price: '$12.75', label: 'Your order is protected for $12.75' },
    { id: 46912083427497, minCart: 851,  maxCart: 900,    price: '$13.50', label: 'Your order is protected for $13.50' },
    { id: 46912083460265, minCart: 901,  maxCart: 950,    price: '$14.25', label: 'Your order is protected for $14.25' },
    { id: 46912083493033, minCart: 951,  maxCart: Infinity, price: '$15.00', label: 'Your order is protected for $15.00' },
  ];
 
  const ALL_PROT_IDS = new Set(PROT_TIERS.map(t => Number(t.id)));
  const ADDON_IDS    = new Set([VAC_ID, COLD_ID, ...ALL_PROT_IDS]);
 
  function getProtTier(subtotalDollars) {
    return PROT_TIERS.find(t => subtotalDollars >= t.minCart && subtotalDollars <= t.maxCart)
      || PROT_TIERS[0];
  }
 
  function updateProtTitle(tier) {
    const el = document.getElementById('pw-title-text');
    if (el) el.textContent = tier.label;
  }
 
  // ─── State flags ─────────────────────────────────────────────────────────
  let _reorderBusy    = false;
  let _manageBusy     = false;
  let _isCheckingOut  = false;
  let _suppressEvents = false;
  let _reorderTimer   = null;
  let _manageTimer    = null;
  let _lastKnownTierId = null;
 
  // ─────────────────────────────────────────────────────────────────────────
  // REGULAR AJAX — UpCart SEES these → price display updates instantly.
  // keepalive: true prevents browser from killing request if user navigates away
  // ─────────────────────────────────────────────────────────────────────────
  async function ajaxPost(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    });
    return r.json();
  }
 
  function getCart() {
    return fetch('/cart.js?_=' + Date.now()).then(r => r.json());
  }
 
  // ─────────────────────────────────────────────────────────────────────────
  // 🚨 CRITICAL FIX: CHECKOUT VALIDATION
  // Blocks checkout if cart only contains addon items (protection/vac/cold)
  // ─────────────────────────────────────────────────────────────────────────
  async function validateCheckout() {
    try {
      const cart = await getCart();
      if (!cart?.items?.length) return true;
 
      const normals = cart.items.filter(i => !ADDON_IDS.has(Number(i.variant_id)));
      
      if (normals.length === 0) {
        console.warn('[Addons] Blocking checkout: cart only contains addon items');
        
        const updates = {};
        cart.items.forEach(item => {
          if (ADDON_IDS.has(Number(item.variant_id))) {
            updates[item.variant_id] = 0;
          }
        });
 
        await ajaxPost('/cart/update.js', { updates });
        
        localStorage.setItem('upcart_vac',  'false');
        localStorage.setItem('upcart_cold', 'false');
        
        if (window.upcart?.refresh) window.upcart.refresh();
        
        return false;
      }
      
      return true;
    } catch(e) {
      console.error('[Addons] Checkout validation error:', e);
      return true;
    }
  }
 
  // ─────────────────────────────────────────────────────────────────────────
  // INTERCEPT CHECKOUT CLICKS
  // ─────────────────────────────────────────────────────────────────────────
  function interceptCheckout(e) {
    const target = e.target;

    // Never intercept cart icon / header cart clicks - let UpCart handle those
    if (target.closest('#cart-icon-bubble') ||
        target.closest('.header__icon--cart') ||
        target.closest('[data-upcart-toggle]') ||
        target.closest('.upcart-icon')) {
      return;
    }

    const isCheckoutButton = 
      target.matches('[name="checkout"]') ||
      target.matches('.upcart-checkout-button') ||
      target.matches('[href*="/checkout"]') ||
      target.closest('[name="checkout"]') ||
      target.closest('.upcart-checkout-button') ||
      target.closest('[href*="/checkout"]');
 
    if (isCheckoutButton && !_isCheckingOut) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Halt any other events tied to this button
      
      _isCheckingOut = true;
      const originalText = target.innerText;
      if (target.innerText) target.innerText = 'Validating...';
      
      validateCheckout().then(isValid => {
        if (isValid) {
          _isCheckingOut = false;
          
          if (target.href && target.href.includes('/checkout')) {
            window.location.href = target.href;
          } else if (target.closest('form')) {
            target.closest('form').submit();
          } else {
            window.location.href = '/checkout';
          }
        } else {
          _isCheckingOut = false;
          if (target.innerText) target.innerText = originalText;
          // Halt checkout because only addons are in cart
          alert("Your cart only contains shipping protection/addons. Please add a product to checkout.");
        }
      }).catch(() => {
        _isCheckingOut = false;
        window.location.href = '/checkout';
      });
    }
  }
 
  document.addEventListener('click', interceptCheckout, false);
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/checkout')) {
      interceptCheckout(e);
    }
  }, false);

 
  // ─────────────────────────────────────────────────────────────────────────
  // SILENT REORDER - Preserves Recharge Subscriptions correctly + keepalive
  // ─────────────────────────────────────────────────────────────────────────
  async function silentReorder() {
    if (_reorderBusy || _isCheckingOut) return;
    _reorderBusy = true;
    try {
      const cart = await getCart();
      if (!cart?.items?.length) return;
 
      const normals = cart.items.filter(i => !ADDON_IDS.has(Number(i.variant_id)));
      if (normals.length === 0) return; // Do not clear the cart if no real items exist
 
      const wantVac    = localStorage.getItem('upcart_vac')  === 'true';
      const wantCold   = localStorage.getItem('upcart_cold') === 'true';
      const activeProt = cart.items.find(i => ALL_PROT_IDS.has(Number(i.variant_id)));
 
      const expected = [];
      if (wantVac)    expected.push(VAC_ID);
      if (wantCold)   expected.push(COLD_ID);
      if (activeProt) expected.push(Number(activeProt.variant_id));
      normals.forEach(n => expected.push(Number(n.variant_id)));
 
      const current = cart.items.map(i => Number(i.variant_id));
      const alreadyOrdered = expected.length === current.length &&
        expected.every((id, idx) => id === current[idx]);
 
      if (alreadyOrdered) return;
 
      const targetItems = [];
      if (wantVac)    targetItems.push({ id: VAC_ID,  quantity: 1 });
      if (wantCold)   targetItems.push({ id: COLD_ID, quantity: 1 });
      if (activeProt) targetItems.push({ id: Number(activeProt.variant_id), quantity: 1 });
      
      normals.forEach(n => {
        const item = { id: n.variant_id, quantity: n.quantity };
        if (n.properties && Object.keys(n.properties).length > 0) item.properties = n.properties;
        
        // Preserve selling_plan for Recharge subscriptions
        if (n.selling_plan_allocation && n.selling_plan_allocation.selling_plan && n.selling_plan_allocation.selling_plan.id) {
            item.selling_plan = n.selling_plan_allocation.selling_plan.id;
        } else if (n.selling_plan) {
            item.selling_plan = n.selling_plan; // Fallback
        }
        
        targetItems.push(item);
      });
 
      if (targetItems.length === 0) return; // Safety fallback

      _suppressEvents = true;
      
      // keepalive: true guarantees this completes even if the user clicks away
      await fetch('/cart/clear.js', { method: 'POST', keepalive: true });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: targetItems }),
        keepalive: true
      });
 
      if (window.upcart?.refresh) window.upcart.refresh();
      
      setTimeout(() => { _suppressEvents = false; }, 1000);
 
    } catch(e) {
      console.error('[Addons] Reorder error:', e);
      _suppressEvents = false;
    } finally {
      _reorderBusy = false;
    }
  }
 
  function scheduleReorder() {
    clearTimeout(_reorderTimer);
    _reorderTimer = setTimeout(silentReorder, 600);
  }
 
  // ─────────────────────────────────────────────────────────────────────────
  // MANAGE PROTECTION
  // ─────────────────────────────────────────────────────────────────────────
  async function manageProtection() {
    if (_manageBusy || _suppressEvents || _isCheckingOut) return;
    _manageBusy = true;
 
    let didSwap = false;
 
    try {
      const cart = await getCart();
      if (!cart?.items) return;
 
      const normals    = cart.items.filter(i => !ADDON_IDS.has(Number(i.variant_id)));
      const hasVac     = cart.items.some(i => Number(i.variant_id) === VAC_ID);
      const hasCold    = cart.items.some(i => Number(i.variant_id) === COLD_ID);
      const activeProt = cart.items.find(i => ALL_PROT_IDS.has(Number(i.variant_id)));
 
      if (normals.length === 0) {
        // ── Cart empty → wipe everything IMMEDIATELY ──
        localStorage.setItem('upcart_vac',  'false');
        localStorage.setItem('upcart_cold', 'false');
 
        if (activeProt || hasVac || hasCold) {
          const updates = {};
          if (activeProt) updates[activeProt.variant_id] = 0;
          if (hasVac)     updates[VAC_ID]  = 0;
          if (hasCold)    updates[COLD_ID] = 0;
          
          await ajaxPost('/cart/update.js', { updates });
          updateProtTitle(PROT_TIERS[0]);
          _lastKnownTierId = null;
          didSwap = true;
        }
 
      } else {
        // ── Cart has normal items → pick correct tier ──
        const normalSubtotalCents   = normals.reduce((sum, i) => sum + i.line_price, 0);
        const normalSubtotalDollars = normalSubtotalCents / 100;
        const correctTier   = getProtTier(normalSubtotalDollars);
        const correctProtId = Number(correctTier.id);
        const activeProtId  = activeProt ? Number(activeProt.variant_id) : null;
 
        updateProtTitle(correctTier);
 
        if (activeProtId === correctProtId) {
          _lastKnownTierId = correctProtId;
          scheduleReorder();
          return;
        }
 
        // ── Wrong tier or missing → swap it out ──
        didSwap = true;
 
        if (activeProt) {
          await ajaxPost('/cart/update.js', { updates: { [activeProt.variant_id]: 0 } });
        }
 
        await ajaxPost('/cart/add.js', { id: correctProtId, quantity: 1 });
 
        _lastKnownTierId = correctProtId;
        scheduleReorder();
      }
    } catch(e) {
      console.error('[Addons] Manage protection error:', e);
    } finally {
      _manageBusy = false;
      if (didSwap) {
        setTimeout(() => scheduleManage(), 1200);
      }
    }
  }
 
  function scheduleManage() {
    clearTimeout(_manageTimer);
    _manageTimer = setTimeout(manageProtection, 400);
  }
 
  // ─────────────────────────────────────────────────────────────────────────
  // CHECKBOX TOGGLE
  // ─────────────────────────────────────────────────────────────────────────
  window.toggleUpcartAddon = function(checkbox, variantId) {
    if (_isCheckingOut) {
      checkbox.checked = !checkbox.checked; // Cancel visually if checking out
      return;
    }
    
    checkbox.disabled = true;
    checkbox.parentElement.style.opacity = '0.55';
 
    const isVac = (Number(variantId) === VAC_ID);
    localStorage.setItem(isVac ? 'upcart_vac' : 'upcart_cold', checkbox.checked);
 
    const action = checkbox.checked
      ? ajaxPost('/cart/add.js',    { id: variantId, quantity: 1 })
      : ajaxPost('/cart/update.js', { updates: { [variantId]: 0 } });
 
    action
      .then(() => scheduleReorder())
      .catch(e => console.error('[Addons] Toggle error:', e))
      .finally(() => {
        checkbox.disabled = false;
        checkbox.parentElement.style.opacity = '1';
      });
  };
 
  // ─────────────────────────────────────────────────────────────────────────
  // CHECKOUT WITHOUT COVERAGE
  // ─────────────────────────────────────────────────────────────────────────
  window.checkoutWithoutCoverage = function(e) {
    e.preventDefault();
    if (_isCheckingOut) return;
    _isCheckingOut = true;
 
    const link = e.currentTarget;
    link.innerText = 'Processing...';
    link.style.opacity = '0.5';
    link.style.pointerEvents = 'none';
 
    const updates = {};
    PROT_TIERS.forEach(t => { updates[t.id] = 0; });
 
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
      keepalive: true
    })
    .then(() => { window.location.href = '/checkout'; })
    .catch(() => { window.location.href = '/checkout'; });
  };
 
  // ─────────────────────────────────────────────────────────────────────────
  // CART:UPDATED LISTENER
  // ─────────────────────────────────────────────────────────────────────────
  document.addEventListener('cart:updated', () => {
    if (_suppressEvents || _isCheckingOut) return;
    scheduleManage();
  });
 
  // ─────────────────────────────────────────────────────────────────────────
  // FALLBACK POLL - More aggressive when cart might be empty
  // ─────────────────────────────────────────────────────────────────────────
  setInterval(async () => {
    if (_manageBusy || _suppressEvents || _isCheckingOut || _reorderBusy) return;
    try {
      const cart = await getCart();
      if (!cart?.items) return;
      const normals = cart.items.filter(i => !ADDON_IDS.has(Number(i.variant_id)));
      
      // If cart only has addons → trigger immediate cleanup
      if (normals.length === 0 && cart.items.length > 0) {
        scheduleManage();
        return;
      }
      
      if (normals.length === 0) return;
 
      const subtotalDollars = normals.reduce((sum, i) => sum + i.line_price, 0) / 100;
      const correctTier     = getProtTier(subtotalDollars);
      const correctProtId   = Number(correctTier.id);
      const activeProt      = cart.items.find(i => ALL_PROT_IDS.has(Number(i.variant_id)));
      const activeProtId    = activeProt ? Number(activeProt.variant_id) : null;
 
      if (activeProtId !== correctProtId) {
        scheduleManage();
      } else {
        updateProtTitle(correctTier);
      }
    } catch(_) {}
  }, 2000);
 
  // ─────────────────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────────────────
  setTimeout(manageProtection, 800);
 
  // ─────────────────────────────────────────────────────────────────────────
  // CHECKBOX VISUAL SYNC
  // ─────────────────────────────────────────────────────────────────────────
  setInterval(() => {
    const vacEl  = document.getElementById('vacuumToggle');
    const coldEl = document.getElementById('coldPackToggle');
    const wantVac  = localStorage.getItem('upcart_vac')  === 'true';
    const wantCold = localStorage.getItem('upcart_cold') === 'true';
    if (vacEl  && vacEl.checked  !== wantVac)  vacEl.checked  = wantVac;
    if (coldEl && coldEl.checked !== wantCold) coldEl.checked = wantCold;
  }, 200);
}